import { createAction } from 'redux-actions'

const ns = 'google-sign-in/'

export const doGoogleSignIn = createAction(`${ns}DO_GOOGLE_SIGN_IN`)
